<template>
  <footer class="main-footer relative z-10" data-testid="main-footer">
    <div class="footer-left" data-testid="footer-left">
      <a :href="websiteUrl" target="_blank" class="flex flex-row items-center text-white/75" data-testid="sorenson-link">
        <span data-testid="powered-by-text">{{ $t('footer_sorenson') !== 'footer_sorenson' ? $t('footer_sorenson') : 'Powered by' }}</span>
        <img src="@/assets/sorenson-logo-compact.svg" class="ml-2 h-[16px] w-auto" data-testid="sorenson-logo"/>
      </a>
      <!-- on mobile the language and legal links live in the settings menu; the picker stays mounted for browser-language detection -->
      <locale-picker :initial="$i18n.locale" class="max-md:hidden" data-testid="locale-picker"></locale-picker>
      <a :href="termsOfUseUrl" target="_blank" class="text-white/75 max-md:hidden" data-testid="terms-of-use-link">{{ $t('terms_of_use')}}</a>
      <a :href="privacyPolicyUrl" target="_blank" class="text-white/75 max-md:hidden" data-testid="privacy-policy-link">{{ $t('support_privacy_title')}}</a>
      <a :href="privacyPortalUrl" target="_blank" class="text-white/75 max-md:hidden" data-testid="privacy-portal-link">{{ $t('privacy_portal_title')}}</a>
      <!-- <a
          href="javascript:;"
          @click="showDSAR"
          class="text-white/75"
          data-testid="privacy-portal-link-main-footer">
          <span class="text-white/90 not-italic font-normal" data-testid="privacy-portal-label-main-footer">
              {{ $t('privacy_portal_title') !== 'privacy_portal_title' ? $t('privacy_portal_title') : 'Privacy Portal' }}
          </span>
      </a> -->
    </div>
    <div class="footer-right" data-testid="footer-right">
      <a class="text-white/75">
        © Sorenson Communications, LLC. All rights reserved.
      </a>
    </div>
  </footer>
   <!-- <drawer-sidebar @closed="dsarFormState = false" :open="dsarFormState" :title="$t('dsar_form')" data-testid="about-forum-dsar-drawer-main-footer">
      <iframe :src="privacyPortalUrl" frameborder="0" data-testid="about-forum-dsar-iframe-main-footer"></iframe>
   </drawer-sidebar> -->
</template>

<script>
// @ is an alias to /src
import LocalePicker from "@/components/LocalePicker";
import { Constants } from '@/cfg/constants';  

export default {
  name: 'MainFooter',
  components: {
    LocalePicker,
  },
  computed: {
    termsOfUseUrl() {
      return Constants.REGION_CONFIG.termsUrl;
    },
    websiteUrl() {
      return Constants.REGION_CONFIG.websiteUrl;
    },
    privacyPolicyUrl() {
      return Constants.REGION_CONFIG.privacyUrl;
    },
    privacyPortalUrl() {
      return Constants.REGION_CONFIG.privacyPortalUrl;
    }
  },
}
</script>

<style lang="scss">
  .main-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    align-items: flex-end;
    padding-bottom: 15px;
    position: relative;
    margin-top: auto;

    .footer-left, .footer-right {
      position: relative;
      z-index: 2;
    }

    .footer-left {
      display: flex;
      gap: 40px;
    }

    .footer-left a {
      font-size: 19px;
      font-style: normal;
      font-weight: 400;
      line-height: 30px; /* 157.895% */
      text-transform: none;
    }

    .footer-center {
      justify-content: center;
      display: flex;
      text-align: center;
      position: absolute;
      width: 100%;
      left: 0;

      &__text {
        margin-bottom: 32px;
      }
    }

    .footer-right a {
       font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 30px; 
      color: #ffffff;
    }
  }

  .footer__cite-text {
    font-weight: 400;
    font-size: 1rem;
    line-height: 24px;
    letter-spacing: 0.10em;
    color: #FFFFFF;
  }

  .footer__cite-author {
    font-weight: 400;
    font-size: 0.93rem;
    line-height: 1.375rem;
    /* identical to box height */
    letter-spacing: 0.10em;
    color: #FFFFFF;
    justify-content: center;
  }

  @media all and (max-width: 1100px) {
    .main-footer {
      flex-direction: column;
      align-items: flex-start;
      padding: 16px;

      .footer-left {
        gap: 8px 24px;
        flex-wrap: wrap;
        justify-content: center;
        display: flex;
        width: 100%;
      }
      .footer-left > a:first-child {
        flex-shrink: 0;
      }
      .footer-right {
        width: 100%;
        margin-top: 8px;
        text-align: center;
      }
      .footer-left a {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        white-space: nowrap;
      }
    }
  }

  // only "Powered by" and the copyright remain on mobile, both aligned to the left edge
  @media all and (max-width: 767px) {
    .main-footer {
      .footer-left {
        justify-content: flex-start;
      }
      .footer-right {
        text-align: left;
      }
    }
  }
</style>
